<div class="modal-content">
    <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLongTitle">Update Profile</h5>
        <button type="button" class="close" (click)="closeDialog()" aria-label="Close">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <form [formGroup]="profileForm">
            <div class="form-group">
                <div class="text-box-wrap">
                    <label>Name</label>
                    <input type="text" formControlName="name" class="form-control"
                        [ngClass]="{'is-invalid': formErrors.name}" maxlength="50">
                    <div class="invalid-feedback" *ngIf="fc.name.errors && fc.name.errors.required">Please
                        enter your name</div>
                </div>
            </div>
            <div class="form-group">
                <div class="text-box-wrap">
                    <label>Mobile</label>
                    <input numberOnly type="text" formControlName="mobile" class="form-control"
                        [ngClass]="{'is-invalid': formErrors.mobile}" maxlength="10">
                        <div *ngIf="fc.mobile.errors" class="invalid-feedback">
                            <div *ngIf="fc.mobile.errors.required">
                                Please enter your Mobile
                            </div>
                            <div *ngIf="fc.mobile.errors.minlength || fc.mobile.errors.maxlength">
                                Mobile must be of 10 Digits
                            </div>
                        </div>
                </div>
            </div>

            <div class="form-group">
                <div class="text-box-wrap">
                    <input type="text" formControlName="email" class="form-control"
                        [ngClass]="{'is-invalid': formErrors.email}" placeholder="Email Address"
                        maxlength="50">
                    <div *ngIf="fc.email.errors" class="invalid-feedback">
                        <div *ngIf="fc.email.errors.required">
                            Please enter your Email address
                        </div>
                        <div *ngIf="fc.email.errors.email">
                            Please enter Valid Email
                        </div>
                    </div>
                </div>
            </div>

        </form>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-secondary " (click)="closeDialog()">Close</button>
        <button type="button" (click)="updateProfile()" [disabled]="!profileForm.valid" class="btn btn-success">Save
            changes</button>
    </div>
</div>